// extracted by mini-css-extract-plugin
export default {"root":"Scale-module_root-srVFk"};